unit UMainMenu;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.Buttons,
  Vcl.Imaging.pngimage, WEBLib.ExtCtrls
{$IFDEF DEBUG}
    , WEBLib.WebTools
{$ENDIF}, Vcl.Menus, WEBLib.WebCtrls, Vcl.StdCtrls, WEBLib.StdCtrls;

type
  TfrmMainMenu = class(TForm)
    divNavBarContainer: THTMLDiv;
    imgLogoMain: TImageControl;
    lblCustomerName: TLabel;
    lblUserName: TLabel;
    divCardContainer: THTMLDiv;
    divNamesContainer: THTMLDiv;
    divMainMenuContainer: THTMLDiv;
    divBitBtn1: THTMLDiv;
    divBitBtn2: THTMLDiv;
    divBitBtn3: THTMLDiv;
    divUserIcon: THTMLDiv;
    divLogoutIcon: THTMLDiv;
    divMainMenuOuterContainer: THTMLDiv;
    divContent: THTMLDiv;
    divHamburgerMenu: THTMLDiv;
    lblHamburgerHome: TLabel;
    lblHamburgerUser: TLabel;
    lblHamburgerLogout: TLabel;
    divHomeIcon: THTMLDiv;
    lbl1: TLabel;
    lbl2: TLabel;
    lbl3: TLabel;
    divBitBtn4: THTMLDiv;
    lbl4: TLabel;
    procedure bitbtnOrdersClick(Sender: TObject);
    procedure bitbtnLogoutClick(Sender: TObject);
    procedure divBitBtn2Click(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormUnload(Sender: TObject);
    procedure WebFormBeforeUnload(Sender: TObject; var AMessage: string);
    procedure WebFormShow(Sender: TObject);
    procedure divHomeIconClick(Sender: TObject);
    procedure divBitBtn3Click(Sender: TObject);
    procedure divBitBtn4Click(Sender: TObject);
  private
    FMsgToken : String;
    [async]procedure UserLogout; async;
    procedure ComingSoon(Sender: TObject);
    procedure SetMsgToken(const Value: String);
    { Private declarations }
  public
    property MsgToken : String read FMsgToken write SetMsgToken;
  protected procedure LoadDFMValues; override; end;

var
  frmMainMenu: TfrmMainMenu;

implementation

{$R *.dfm}

uses
  ULogin, UOrders, UOrdersMain, UHelper, UResources, UDatamodule, UJSHelper,
  UUsersMain, ULogisticOverview, UAnalysis;

procedure TfrmMainMenu.bitbtnLogoutClick(Sender: TObject);
begin
  UserLogout;
//  window.sessionStorage.removeItem(sSessionStorageKey);
end;

procedure TfrmMainMenu.bitbtnOrdersClick(Sender: TObject);
var
  lform: TfrmOrdersMain;
begin
  if Assigned(lform) then
  begin
    lform.Close;
  end;

  frmOrdersMain := TfrmOrdersMain.CreateNew(divContent.ElementID, nil);
end;


procedure TfrmMainMenu.ComingSoon(Sender: TObject);
begin
  MessageDlg('This feature is coming soon...', mtinformation, [mbOK]);
end;



procedure TfrmMainMenu.UserLogout;
var
  lform: TfrmLogin;
begin
  if Assigned(lform) then
  begin
    lform.Close;
  end;
  lform := TfrmLogin.CreateNew(divMainMenuOuterContainer.ElementID, nil);
  //  frmLogin := TfrmLogin.Create(self);
  //  frmLogin.Popup:= false;
  //
  //  try
  //    await(TfrmLogin, frmLogin.Load());
  //  finally
  //  end;
  UDM.AccessToken := '';
  UDM.LoginToken := '';
  await(lform.LogoutAsync(UDM.UserID));
end;

procedure TfrmMainMenu.divBitBtn2Click(Sender: TObject);
var
  lForm: TfrmLogisticOverview;
begin
  if Assigned(lForm) then
  begin
    lForm.Close;
  end;

  lForm := TfrmLogisticOverview.CreateNew(divContent.ElementID, nil);
end;


procedure TfrmMainMenu.divBitBtn3Click(Sender: TObject);
var
  lForm: TfrmUsersMain;
begin
  if Assigned(lForm) then
  begin
    lForm.Close;
  end;

  lForm := TfrmUsersMain.CreateNew(divContent.ElementID, nil);
end;


procedure TfrmMainMenu.divBitBtn4Click(Sender: TObject);
var
  lForm: TfrmAnalysis;
begin
  if Assigned(lForm) then
  begin
    lForm.Close;
  end;

  lForm := TfrmAnalysis.CreateNew(divContent.ElementID, nil);
end;

procedure TfrmMainMenu.WebFormBeforeUnload(Sender: TObject;
  var AMessage: string);
begin
{$IFDEF RELEASE}
  AMessage := sLeaving;
{$ENDIF}
end;


procedure TfrmMainMenu.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Action := TCloseAction.caFree;
end;

procedure TfrmMainMenu.WebFormCreate(Sender: TObject);
begin
//  THelper.DebugODS('onCreate main form complete');
//  THelper.DebugODS('onShow main form complete');
  {$IFDEF PAS2JS}
  asm
    var width575 = window.matchMedia("(max-width: 575px)");
    width575.addEventListener("change", function() {
      pas.UJSHelper.THTMLComponents.LangResize(width575);
     });

    if(width575.matches){
      pas.UJSHelper.THTMLComponents.LangResize(width575);
    }

  end;
  {$ENDIF}
end;

procedure TfrmMainMenu.WebFormShow(Sender: TObject);
begin
  // Moved to onShow not working onCreate -> firefox
  if UDM.CustomerName <> '' then
    lblCustomerName.Caption := UDM.CustomerName;
  if UDM.UserMail <> '' then
    lblUserName.Caption := UDM.UserMail;

  divBitBtn2.Visible := UDM.LogisticRights;
  divBitBtn3.Visible := UDM.AdminRights;
  divBitBtn4.Visible := UDM.AdminRights;

  FMsgToken := '';

  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.LanguageInit();
    pas.UJSHelper.THTMLComponents.MainMenuInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();

    const msg = firebase.messaging();

    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    } else if (Notification.permission === "granted") {
        msg.getToken(msg, {vapidKey: "BDcFkcmFcaHYHkf6kpwLbXM-yN-8cNE_FId5JHzfW1jQxnRDNNHYw2we5UJCQiPVP_QBPRYuNufQTPbNCwoFR7Q"}).then((currentToken) => {
          if (currentToken) {
            pas.UMainMenu.TfrmMainMenu.SetMsgToken(currentToken);
            msg.onMessage((payload) => {
              console.log("Message received. ", payload);
              const notificationTitle = payload.notification.title;
              const notificationOptions = {
                body: payload.notification.body,
                icon: "/firebase-logo.png",
                tag: payload.data.ID
              };
              console.log(payload.data.ID);
              const notification = new Notification(notificationTitle, notificationOptions);
              notification.onclick = (event) => {
                window.open("https://fliegel-portal.de/?Nr=" + event.target.tag + "&JumpToPage=OrdersMenu", "_self");
              };
            });
          }
        }).catch((err) => {
          console.log("An error occurred while retrieving token. ", err);
        });
    }

  end;
  {$ENDIF}

  if (UDM.JumpToPage = sPageOrdersMenu) and (UDM.Form = sPageLogin) then
  begin
    self.bitbtnOrdersClick(self);
  end;
end;


procedure TfrmMainMenu.WebFormUnload(Sender: TObject);
begin
  if (sLeaving = '') then
    MessageDlg('now', mtinformation, [mbOK]);
end;


procedure TfrmMainMenu.divHomeIconClick(Sender: TObject);
var
  lform: TfrmMainMenu;
begin
  if Assigned(lform) then
  begin
    lform.Close;
  end;
  UDM.Form :=sPageMainMenu;
  lform := TfrmMainMenu.CreateNew(divMainMenuOuterContainer.ElementID, nil);
  // Application.CreateForm(TfrmMainMenu, divFormContainer.ElementID, lform);
end;


procedure TfrmMainMenu.SetMsgToken(const Value: String);
begin
  FMsgToken := Value;

  THelper.DebugODS('Delphi-Token: ' + FMsgToken);

  UDM.XDataWebClient.RawInvokeAsync('IMessaging.UpdateToken',
      [UDM.UserID, FMsgToken]);
end;


procedure TfrmMainMenu.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divMainMenuOuterContainer := THTMLDiv.Create('wcIDFormContainer');
  divMainMenuContainer := THTMLDiv.Create('wcIDMainContainer');
  divNavBarContainer := THTMLDiv.Create('wcIDNavBar');
  imgLogoMain := TImageControl.Create('wcIDNavLogoImg');
  divNamesContainer := THTMLDiv.Create('wcIDNavNames');
  lblCustomerName := TLabel.Create('wcIDCustomerName');
  lblUserName := TLabel.Create('wcIDUserName');
  divUserIcon := THTMLDiv.Create('wcIDNavUserIcon');
  divLogoutIcon := THTMLDiv.Create('wcIDNavLogoutIcon');
  divHomeIcon := THTMLDiv.Create('wcIDHomeIcon');
  divContent := THTMLDiv.Create('wcIDContent');
  divCardContainer := THTMLDiv.Create('wcIDCardContainer');
  divBitBtn1 := THTMLDiv.Create('wcIDCardBtn1');
  lbl1 := TLabel.Create('wcIDLabel1');
  divBitBtn2 := THTMLDiv.Create('wcIDCardBtn2');
  lbl2 := TLabel.Create('wcIDLabel2');
  divBitBtn3 := THTMLDiv.Create('wcIDCardBtn3');
  lbl3 := TLabel.Create('wcIDLabel3');
  divBitBtn4 := THTMLDiv.Create('wcIDCardBtn4');
  lbl4 := TLabel.Create('wcIDLabel4');
  divHamburgerMenu := THTMLDiv.Create(Self);
  lblHamburgerHome := TLabel.Create('wcIDSideNavHome');
  lblHamburgerUser := TLabel.Create('wcIDSideNavUser');
  lblHamburgerLogout := TLabel.Create('wcIDSideNavLogout');

  divMainMenuOuterContainer.BeforeLoadDFMValues;
  divMainMenuContainer.BeforeLoadDFMValues;
  divNavBarContainer.BeforeLoadDFMValues;
  imgLogoMain.BeforeLoadDFMValues;
  divNamesContainer.BeforeLoadDFMValues;
  lblCustomerName.BeforeLoadDFMValues;
  lblUserName.BeforeLoadDFMValues;
  divUserIcon.BeforeLoadDFMValues;
  divLogoutIcon.BeforeLoadDFMValues;
  divHomeIcon.BeforeLoadDFMValues;
  divContent.BeforeLoadDFMValues;
  divCardContainer.BeforeLoadDFMValues;
  divBitBtn1.BeforeLoadDFMValues;
  lbl1.BeforeLoadDFMValues;
  divBitBtn2.BeforeLoadDFMValues;
  lbl2.BeforeLoadDFMValues;
  divBitBtn3.BeforeLoadDFMValues;
  lbl3.BeforeLoadDFMValues;
  divBitBtn4.BeforeLoadDFMValues;
  lbl4.BeforeLoadDFMValues;
  divHamburgerMenu.BeforeLoadDFMValues;
  lblHamburgerHome.BeforeLoadDFMValues;
  lblHamburgerUser.BeforeLoadDFMValues;
  lblHamburgerLogout.BeforeLoadDFMValues;
  try
    Name := 'frmMainMenu';
    Width := 1070;
    Height := 712;
    ElementPosition := epIgnore;
    SetEvent(Self, 'OnBeforeUnload', 'WebFormBeforeUnload');
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    SetEvent(Self, 'OnUnload', 'WebFormUnload');
    divMainMenuOuterContainer.SetParentComponent(Self);
    divMainMenuOuterContainer.Name := 'divMainMenuOuterContainer';
    divMainMenuOuterContainer.Left := 0;
    divMainMenuOuterContainer.Top := 0;
    divMainMenuOuterContainer.Width := 1070;
    divMainMenuOuterContainer.Height := 712;
    divMainMenuOuterContainer.HeightStyle := ssAuto;
    divMainMenuOuterContainer.WidthStyle := ssAuto;
    divMainMenuOuterContainer.Align := alClient;
    divMainMenuOuterContainer.ChildOrder := 1;
    divMainMenuOuterContainer.ElementPosition := epIgnore;
    divMainMenuOuterContainer.ElementFont := efCSS;
    divMainMenuOuterContainer.Role := '';
    divMainMenuContainer.SetParentComponent(divMainMenuOuterContainer);
    divMainMenuContainer.Name := 'divMainMenuContainer';
    divMainMenuContainer.Left := 0;
    divMainMenuContainer.Top := 0;
    divMainMenuContainer.Width := 1070;
    divMainMenuContainer.Height := 712;
    divMainMenuContainer.ElementClassName := 'wcCLMainContainer';
    divMainMenuContainer.HeightStyle := ssAuto;
    divMainMenuContainer.WidthStyle := ssAuto;
    divMainMenuContainer.Align := alClient;
    divMainMenuContainer.ChildOrder := 1;
    divMainMenuContainer.ElementPosition := epIgnore;
    divMainMenuContainer.ElementFont := efCSS;
    divMainMenuContainer.Role := '';
    divNavBarContainer.SetParentComponent(divMainMenuContainer);
    divNavBarContainer.Name := 'divNavBarContainer';
    divNavBarContainer.Left := 0;
    divNavBarContainer.Top := 0;
    divNavBarContainer.Width := 1070;
    divNavBarContainer.Height := 105;
    divNavBarContainer.ElementClassName := 'navbar navbar-light navbar-expand bg-faded border-bottom wcCLNavBar';
    divNavBarContainer.HeightStyle := ssAuto;
    divNavBarContainer.WidthStyle := ssAuto;
    divNavBarContainer.Align := alTop;
    divNavBarContainer.ElementPosition := epIgnore;
    divNavBarContainer.Role := '';
    imgLogoMain.SetParentComponent(divNavBarContainer);
    imgLogoMain.Name := 'imgLogoMain';
    imgLogoMain.Left := 410;
    imgLogoMain.Top := 3;
    imgLogoMain.Width := 255;
    imgLogoMain.Height := 96;
    imgLogoMain.ElementClassName := 'nav-item d-lg-block text-center';
    imgLogoMain.HeightStyle := ssAuto;
    imgLogoMain.WidthStyle := ssAuto;
    imgLogoMain.HeightPercent := 100.000000000000000000;
    imgLogoMain.WidthPercent := 100.000000000000000000;
    imgLogoMain.ChildOrder := 3;
    imgLogoMain.ElementPosition := epIgnore;
    imgLogoMain.Picture.LoadFromFile('UMainMenu.divNavBarContainer.imgLogoMain.Picture.png');
    divNamesContainer.SetParentComponent(divNavBarContainer);
    divNamesContainer.Name := 'divNamesContainer';
    divNamesContainer.Left := 712;
    divNamesContainer.Top := 17;
    divNamesContainer.Width := 99;
    divNamesContainer.Height := 72;
    divNamesContainer.ElementClassName := 'nav-item wcCLNavNames';
    divNamesContainer.HeightStyle := ssAuto;
    divNamesContainer.WidthStyle := ssAuto;
    divNamesContainer.ChildOrder := 6;
    divNamesContainer.ElementPosition := epIgnore;
    divNamesContainer.Role := '';
    lblCustomerName.SetParentComponent(divNamesContainer);
    lblCustomerName.Name := 'lblCustomerName';
    lblCustomerName.Left := 10;
    lblCustomerName.Top := 9;
    lblCustomerName.Width := 90;
    lblCustomerName.Height := 15;
    lblCustomerName.Caption := 'Customer Name ';
    lblCustomerName.ElementClassName := 'nav-link mb-0';
    lblCustomerName.ElementPosition := epIgnore;
    lblCustomerName.HeightStyle := ssAuto;
    lblCustomerName.HeightPercent := 100.000000000000000000;
    lblCustomerName.WidthStyle := ssAuto;
    lblCustomerName.WidthPercent := 100.000000000000000000;
    lblUserName.SetParentComponent(divNamesContainer);
    lblUserName.Name := 'lblUserName';
    lblUserName.Left := 21;
    lblUserName.Top := 44;
    lblUserName.Width := 61;
    lblUserName.Height := 15;
    lblUserName.Caption := 'User Name ';
    lblUserName.ElementClassName := 'nav-link mb-0 py-0';
    lblUserName.ElementPosition := epIgnore;
    lblUserName.HeightStyle := ssAuto;
    lblUserName.HeightPercent := 100.000000000000000000;
    lblUserName.WidthStyle := ssAuto;
    lblUserName.WidthPercent := 100.000000000000000000;
    divUserIcon.SetParentComponent(divNavBarContainer);
    divUserIcon.Name := 'divUserIcon';
    divUserIcon.Left := 823;
    divUserIcon.Top := 26;
    divUserIcon.Width := 81;
    divUserIcon.Height := 59;
    divUserIcon.ElementClassName := 'nav-item mx-4 wcCLListItemIcon wcCLNavIcons';
    divUserIcon.HeightStyle := ssAuto;
    divUserIcon.WidthStyle := ssAuto;
    divUserIcon.ChildOrder := 5;
    divUserIcon.ElementPosition := epIgnore;
    divUserIcon.ElementFont := efCSS;
    divUserIcon.Role := '';
    divLogoutIcon.SetParentComponent(divNavBarContainer);
    divLogoutIcon.Name := 'divLogoutIcon';
    divLogoutIcon.Left := 910;
    divLogoutIcon.Top := 26;
    divLogoutIcon.Width := 83;
    divLogoutIcon.Height := 59;
    divLogoutIcon.ElementClassName := 'nav-item wcCLListItemIcon wcCLNavIcons';
    divLogoutIcon.HeightStyle := ssAuto;
    divLogoutIcon.WidthStyle := ssAuto;
    divLogoutIcon.ChildOrder := 5;
    divLogoutIcon.ElementPosition := epIgnore;
    divLogoutIcon.ElementFont := efCSS;
    divLogoutIcon.Role := '';
    SetEvent(divLogoutIcon, Self, 'OnClick', 'bitbtnLogoutClick');
    divHomeIcon.SetParentComponent(divNavBarContainer);
    divHomeIcon.Name := 'divHomeIcon';
    divHomeIcon.Left := 24;
    divHomeIcon.Top := 17;
    divHomeIcon.Width := 83;
    divHomeIcon.Height := 68;
    divHomeIcon.ElementClassName := 'nav-item mx-1 wcCLNavIcons';
    divHomeIcon.HeightStyle := ssAuto;
    divHomeIcon.WidthStyle := ssAuto;
    divHomeIcon.ChildOrder := 5;
    divHomeIcon.ElementPosition := epIgnore;
    divHomeIcon.ElementFont := efCSS;
    divHomeIcon.Role := '';
    SetEvent(divHomeIcon, Self, 'OnClick', 'divHomeIconClick');
    divContent.SetParentComponent(divMainMenuContainer);
    divContent.Name := 'divContent';
    divContent.Left := 0;
    divContent.Top := 105;
    divContent.Width := 1070;
    divContent.Height := 607;
    divContent.HeightStyle := ssAuto;
    divContent.WidthStyle := ssAuto;
    divContent.Align := alClient;
    divContent.ChildOrder := 2;
    divContent.ElementPosition := epIgnore;
    divContent.ElementFont := efCSS;
    divContent.Role := '';
    divCardContainer.SetParentComponent(divContent);
    divCardContainer.Name := 'divCardContainer';
    divCardContainer.Left := 0;
    divCardContainer.Top := 0;
    divCardContainer.Width := 1070;
    divCardContainer.Height := 607;
    divCardContainer.ElementClassName := 'wcCLCardOuterContainer row row-cols-1 row-cols-xl-4 row-cols-md-3 row-cols-sm-2 row-cols-xs-1 my-3 g-4 mx-auto text-center';
    divCardContainer.HeightStyle := ssAuto;
    divCardContainer.WidthStyle := ssAuto;
    divCardContainer.Align := alClient;
    divCardContainer.ChildOrder := 1;
    divCardContainer.ElementPosition := epIgnore;
    divCardContainer.ElementFont := efCSS;
    divCardContainer.Role := '';
    divBitBtn1.SetParentComponent(divCardContainer);
    divBitBtn1.Name := 'divBitBtn1';
    divBitBtn1.Left := 3;
    divBitBtn1.Top := 6;
    divBitBtn1.Width := 264;
    divBitBtn1.Height := 192;
    divBitBtn1.ElementClassName := 'wcCLCardItem card h-100 pt-4';
    divBitBtn1.HeightStyle := ssAuto;
    divBitBtn1.WidthStyle := ssAuto;
    divBitBtn1.ChildOrder := 12;
    divBitBtn1.ElementPosition := epIgnore;
    divBitBtn1.ElementFont := efCSS;
    divBitBtn1.Role := '';
    SetEvent(divBitBtn1, Self, 'OnClick', 'bitbtnOrdersClick');
    lbl1.SetParentComponent(divBitBtn1);
    lbl1.Name := 'lbl1';
    lbl1.Left := 48;
    lbl1.Top := 152;
    lbl1.Width := 189;
    lbl1.Height := 15;
    lbl1.Caption := 'Aktuelle Containerinfos '#252'bermitteln';
    lbl1.ElementClassName := 'wcCLCardText card-text';
    lbl1.ElementFont := efCSS;
    lbl1.HeightPercent := 100.000000000000000000;
    lbl1.WidthPercent := 100.000000000000000000;
    divBitBtn2.SetParentComponent(divCardContainer);
    divBitBtn2.Name := 'divBitBtn2';
    divBitBtn2.Left := 273;
    divBitBtn2.Top := 6;
    divBitBtn2.Width := 264;
    divBitBtn2.Height := 192;
    divBitBtn2.ElementClassName := 'wcCLCardItem card h-100 pt-4';
    divBitBtn2.HeightStyle := ssAuto;
    divBitBtn2.WidthStyle := ssAuto;
    divBitBtn2.ChildOrder := 12;
    divBitBtn2.ElementPosition := epIgnore;
    divBitBtn2.ElementFont := efCSS;
    divBitBtn2.Role := '';
    SetEvent(divBitBtn2, Self, 'OnClick', 'divBitBtn2Click');
    lbl2.SetParentComponent(divBitBtn2);
    lbl2.Name := 'lbl2';
    lbl2.Left := 72;
    lbl2.Top := 152;
    lbl2.Width := 104;
    lbl2.Height := 15;
    lbl2.Caption := 'Gemeldete Mengen';
    lbl2.ElementClassName := 'wcCLCardText card-text';
    lbl2.ElementFont := efCSS;
    lbl2.HeightPercent := 100.000000000000000000;
    lbl2.WidthPercent := 100.000000000000000000;
    divBitBtn3.SetParentComponent(divCardContainer);
    divBitBtn3.Name := 'divBitBtn3';
    divBitBtn3.Left := 536;
    divBitBtn3.Top := 6;
    divBitBtn3.Width := 264;
    divBitBtn3.Height := 192;
    divBitBtn3.ElementClassName := 'wcCLCardItem card h-100 pt-4';
    divBitBtn3.HeightStyle := ssAuto;
    divBitBtn3.WidthStyle := ssAuto;
    divBitBtn3.ChildOrder := 14;
    divBitBtn3.ElementPosition := epIgnore;
    divBitBtn3.ElementFont := efCSS;
    divBitBtn3.Role := '';
    SetEvent(divBitBtn3, Self, 'OnClick', 'divBitBtn3Click');
    lbl3.SetParentComponent(divBitBtn3);
    lbl3.Name := 'lbl3';
    lbl3.Left := 88;
    lbl3.Top := 152;
    lbl3.Width := 100;
    lbl3.Height := 15;
    lbl3.Caption := 'Benutzer verwalten';
    lbl3.ElementClassName := 'wcCLCardText card-text';
    lbl3.ElementFont := efCSS;
    lbl3.HeightPercent := 100.000000000000000000;
    lbl3.WidthPercent := 100.000000000000000000;
    divBitBtn4.SetParentComponent(divCardContainer);
    divBitBtn4.Name := 'divBitBtn4';
    divBitBtn4.Left := 243;
    divBitBtn4.Top := 262;
    divBitBtn4.Width := 264;
    divBitBtn4.Height := 192;
    divBitBtn4.ElementClassName := 'wcCLCardItem card h-100 pt-4';
    divBitBtn4.HeightStyle := ssAuto;
    divBitBtn4.WidthStyle := ssAuto;
    divBitBtn4.ChildOrder := 14;
    divBitBtn4.ElementPosition := epIgnore;
    divBitBtn4.ElementFont := efCSS;
    divBitBtn4.Role := '';
    SetEvent(divBitBtn4, Self, 'OnClick', 'divBitBtn4Click');
    lbl4.SetParentComponent(divBitBtn4);
    lbl4.Name := 'lbl4';
    lbl4.Left := 88;
    lbl4.Top := 144;
    lbl4.Width := 77;
    lbl4.Height := 15;
    lbl4.Caption := 'Auswertungen';
    lbl4.ElementClassName := 'wcCLCardText card-text';
    lbl4.HeightPercent := 100.000000000000000000;
    lbl4.WidthPercent := 100.000000000000000000;
    divHamburgerMenu.SetParentComponent(divMainMenuContainer);
    divHamburgerMenu.Name := 'divHamburgerMenu';
    divHamburgerMenu.Left := 851;
    divHamburgerMenu.Top := 141;
    divHamburgerMenu.Width := 365;
    divHamburgerMenu.Height := 532;
    divHamburgerMenu.HeightStyle := ssAuto;
    divHamburgerMenu.WidthStyle := ssAuto;
    divHamburgerMenu.ChildOrder := 1;
    divHamburgerMenu.ElementPosition := epIgnore;
    divHamburgerMenu.ElementFont := efCSS;
    divHamburgerMenu.Role := '';
    lblHamburgerHome.SetParentComponent(divHamburgerMenu);
    lblHamburgerHome.Name := 'lblHamburgerHome';
    lblHamburgerHome.Left := 45;
    lblHamburgerHome.Top := 136;
    lblHamburgerHome.Width := 64;
    lblHamburgerHome.Height := 15;
    lblHamburgerHome.Caption := 'Hauptmen'#252;
    lblHamburgerHome.HeightPercent := 100.000000000000000000;
    lblHamburgerHome.WidthPercent := 100.000000000000000000;
    SetEvent(lblHamburgerHome, Self, 'OnClick', 'divHomeIconClick');
    lblHamburgerUser.SetParentComponent(divHamburgerMenu);
    lblHamburgerUser.Name := 'lblHamburgerUser';
    lblHamburgerUser.Left := 47;
    lblHamburgerUser.Top := 176;
    lblHamburgerUser.Width := 46;
    lblHamburgerUser.Height := 15;
    lblHamburgerUser.Caption := 'Benutzer';
    lblHamburgerUser.HeightPercent := 100.000000000000000000;
    lblHamburgerUser.WidthPercent := 100.000000000000000000;
    lblHamburgerLogout.SetParentComponent(divHamburgerMenu);
    lblHamburgerLogout.Name := 'lblHamburgerLogout';
    lblHamburgerLogout.Left := 47;
    lblHamburgerLogout.Top := 210;
    lblHamburgerLogout.Width := 57;
    lblHamburgerLogout.Height := 15;
    lblHamburgerLogout.Caption := 'Ausloggen';
    lblHamburgerLogout.HeightPercent := 100.000000000000000000;
    lblHamburgerLogout.WidthPercent := 100.000000000000000000;
    SetEvent(lblHamburgerLogout, Self, 'OnClick', 'bitbtnLogoutClick');
  finally
    divMainMenuOuterContainer.AfterLoadDFMValues;
    divMainMenuContainer.AfterLoadDFMValues;
    divNavBarContainer.AfterLoadDFMValues;
    imgLogoMain.AfterLoadDFMValues;
    divNamesContainer.AfterLoadDFMValues;
    lblCustomerName.AfterLoadDFMValues;
    lblUserName.AfterLoadDFMValues;
    divUserIcon.AfterLoadDFMValues;
    divLogoutIcon.AfterLoadDFMValues;
    divHomeIcon.AfterLoadDFMValues;
    divContent.AfterLoadDFMValues;
    divCardContainer.AfterLoadDFMValues;
    divBitBtn1.AfterLoadDFMValues;
    lbl1.AfterLoadDFMValues;
    divBitBtn2.AfterLoadDFMValues;
    lbl2.AfterLoadDFMValues;
    divBitBtn3.AfterLoadDFMValues;
    lbl3.AfterLoadDFMValues;
    divBitBtn4.AfterLoadDFMValues;
    lbl4.AfterLoadDFMValues;
    divHamburgerMenu.AfterLoadDFMValues;
    lblHamburgerHome.AfterLoadDFMValues;
    lblHamburgerUser.AfterLoadDFMValues;
    lblHamburgerLogout.AfterLoadDFMValues;
  end;
end;

initialization

RegisterClass(TfrmMainMenu);

end.
